import { BreakpointsOptions, ThemeOptions } from '@mui/material/styles';
import { FONT_WEIGHT_MEDIUM } from '../enums/FontType';
import { hoverFix } from './styles/mixins';

const breakpoints: BreakpointsOptions = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
};

export const globalThemeOptions: ThemeOptions = {
  breakpoints,
  palette: {
    primary: {
      main: '#007bff',
      light: '#fff',
    },
    secondary: {
      dark: '#234cc9',
      main: '#007bff',
      light: '#1992fb',
    },
    error: {
      main: '#dc3545',
    },
    info: {
      main: '#dadada',
    },
    icon: {
      main: '#007bff',
    },
    common: {
      white: '#fff',
      black: '#000',
    },
  },
  /**
   * Fixes a conflict with Boostrap-reboot forcing a color on a:hover
   * <a> is used for sale  and crm integration buttons
   *
   * @see https://github.com/mui/material-ui/pull/22293
   */
  components: {
    MuiAlert: {
      styleOverrides: {
        action: {
          alignItems: 'center',
          paddingTop: 0,
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        listbox: {
          '& .MuiAutocomplete-option[aria-selected="true"], & .MuiAutocomplete-option[aria-selected="true"].Mui-focused':
            {
              backgroundColor: 'rgba(0, 0, 0, 0.08)',
            },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          '&:hover': {
            color: 'white',
          },
        },
        containedSecondary: {
          '&:hover': {
            color: 'white',
          },
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: '8px 24px',
        },
      },
    },
    MuiLink: {
      defaultProps: {
        underline: 'hover',
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          ...hoverFix,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          ...hoverFix,
          '& .MuiListItemIcon-root': {
            minWidth: '24px',
          },
          '& .MuiListItemText-root': {
            marginBottom: '4px',
            marginTop: '4px',
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          lineHeight: 1.75,
        },
      },
    },
    MuiTooltip: {
      defaultProps: {
        arrow: true,
      },
      styleOverrides: {
        arrow: {
          color: 'var(--tooltip-solid-color)',
        },
        tooltip: {
          backgroundColor: 'var(--tooltip-solid-color)',
        },
      },
    },
  },
  /**
   * Defining the default font weight for medium/bold typography elements
   * (h1 to h6) to 400, because the default is 500. However, the default
   * Inter font variants loaded for the app (check root.css) are 400 and 700.
   * So, any bold elements with font-weight: 500 will be displayed the same as
   * being font-weight: 400, as it's the only available variant.
   *
   * This solves an issue when the Inter font variants are loaded for the
   * font selector (in the org settings page) and a visual change can be noticed
   * when the titles change to font-weight: 500.
   */
  typography: {
    fontFamily: 'Inter, Arial, sans-serif',
    fontWeightMedium: FONT_WEIGHT_MEDIUM,
  },
};
